import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProfileContext } from '../../../context/Profile.context';
import { Box, Checkbox, Label, Tooltip, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import { tooltips } from '../../../constants';
import { testIds } from '../../../constants/testIds';
import { InfoIcon } from 'lucide-react';

const OrganizationalStage = () => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const profileData = profileState.profile;
    const isReadOnly = profileState.readOnly;

    const onValueChanged = updatedObj => {
        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'companyInfo',
            payload: updatedObj.companyInfo
        });
    };

    return <Box display='grid' gap={2} gridTemplateColumns={{ desktop: 'repeat(6, 1fr)', mobile: '1fr' }}>
        <Box gridColumn='span 6'>
            <Typography variant='h4' mb={0}>Organizational Stage</Typography>
        </Box>
        <Box gridColumn='span 6'>
            <Typography variant='body1'>
                Indicate if the Company is currently organized as a Shell or any of the other options listed below. If not, leave all options unchecked.
            </Typography>
        </Box>
        {isReadOnly && <Box gridColumn='span 3'>
            <Label htmlFor='blankCheck' tooltipDark tooltipSubtitle={tooltips.BLANK_CHECK}>Blank Check</Label>
            <Typography mt={2} variant='body1' data-testid={testIds.companyInfo.orgStage.blankCheck}>{profileData.companyInfo.organizationIndicators.blankCheck ? 'Yes' : 'No'}</Typography>
        </Box>}
        {!isReadOnly && <Box gridColumn='span 3' display='flex' alignItems='center'>
            <Checkbox
                data-testid={testIds.companyInfo.orgStage.blankCheck}
                label='Blank Check'
                checked={profileData.companyInfo.organizationIndicators.blankCheck}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, organizationIndicators: { ...profileData.companyInfo.organizationIndicators, blankCheck: e.target.checked } } })}
            />
            <Box display='flex' ml={-1}>
                <Tooltip dark subtitle={tooltips.BLANK_CHECK}><InfoIcon color='var(--otc-green)' size={14} /></Tooltip>
            </Box>
        </Box>}

        {isReadOnly && <Box gridColumn='span 3'>
            <Label htmlFor='shell' tooltipDark tooltipSubtitle={tooltips.SHELL}>Shell Company</Label>
            <Typography mt={2} variant='body1' data-testid={testIds.companyInfo.orgStage.shell}>{profileData.companyInfo.organizationIndicators.shell ? 'Yes' : 'No'}</Typography>
        </Box>}
        {!isReadOnly && <Box gridColumn='span 3' display='flex' alignItems='center'>
            <Checkbox
                data-testid={testIds.companyInfo.orgStage.shell}
                label='Shell Company'
                checked={profileData.companyInfo.organizationIndicators.shell}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, organizationIndicators: { ...profileData.companyInfo.organizationIndicators, shell: e.target.checked } } })}
            />
            <Box display='flex' ml={-1}>
                <Tooltip dark subtitle={tooltips.SHELL}><InfoIcon color='var(--otc-green)' size={14} /></Tooltip>
            </Box>
        </Box>}

        {isReadOnly && <Box gridColumn='span 3'>
            <Label htmlFor='spac' tooltipDark tooltipSubtitle={tooltips.SPAC}>SPAC</Label>
            <Typography mt={2} variant='body1' data-testid={testIds.companyInfo.orgStage.spac}>{profileData.companyInfo.organizationIndicators.spac ? 'Yes' : 'No'}</Typography>
        </Box>}
        {!isReadOnly && <Box gridColumn='span 3' display='flex' alignItems='center'>
            <Checkbox
                data-testid={testIds.companyInfo.orgStage.spac}
                label='SPAC'
                checked={profileData.companyInfo.organizationIndicators.spac}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, organizationIndicators: { ...profileData.companyInfo.organizationIndicators, spac: e.target.checked } } })}
            />
            <Box display='flex' ml={-1}>
                <Tooltip dark subtitle={tooltips.SPAC}><InfoIcon color='var(--otc-green)' size={14} /></Tooltip>
            </Box>
        </Box>}

        {isReadOnly && <Box gridColumn='span 3'>
            <Label htmlFor='blindPool' tooltipDark tooltipSubtitle={tooltips.BLIND_POOL}>Blind Pool</Label>
            <Typography mt={2} variant='body1' data-testid={testIds.companyInfo.orgStage.blindPool}>{profileData.companyInfo.organizationIndicators.blindPool ? 'Yes' : 'No'}</Typography>
        </Box>}
        {!isReadOnly && <Box gridColumn='span 3' display='flex' alignItems='center'>
            <Checkbox
                data-testid={testIds.companyInfo.orgStage.blindPool}
                label='Blind Pool'
                checked={profileData.companyInfo.organizationIndicators.blindPool}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, organizationIndicators: { ...profileData.companyInfo.organizationIndicators, blindPool: e.target.checked } } })}
            />
            <Box display='flex' ml={-1}>
                <Tooltip dark subtitle={tooltips.BLIND_POOL}><InfoIcon color='var(--otc-green)' size={14} /></Tooltip>
            </Box>
        </Box>}
    </Box>;
};

export default OrganizationalStage;
